import {webviewFlowIdIsSupport, webviewGenerateFlowId} from "../utils/webview-api/flow-id";

async function shouldGenerateFlowId(queryParams) {
  try {
    if (queryParams["flow_id"]) {
      return false;
    }

    await window.clientConfig?.webviewContextReady;

    return webviewFlowIdIsSupport();
  } catch (error) {
    console.error("[flow-id] failed to check flow_id support", error);
    return false;
  }
}

async function generateFlowId(queryParams, reason) {
  try {
    const response = await webviewGenerateFlowId();
    const flowId = response.ok ? response.result?.flowId : undefined;

    if (typeof flowId === "string" && flowId.length > 0) {
      queryParams["flow_id"] = flowId;
    }
  } catch (error) {
    console.error(`[flow-id] failed to generate flow_id on ${reason}`, error);
  }
}

function syncFlowId(queryParams, showed) {
  try {
    const isBottomTab = showed === "tab";
    const isFlowIdManagedByHost = showed === "combo";

    if (!isBottomTab) {
      if (!isFlowIdManagedByHost) {
        void (async () => {
          if (await shouldGenerateFlowId(queryParams)) {
            await generateFlowId(queryParams, "load");
          }
        })();
      }

      return () => {};
    }

    const tabSelected = window.webviewEventsListeners?.tabSelected;
    if (!tabSelected) {
      console.warn("[flow-id] window.webviewEventsListeners.tabSelected is unavailable");
      return () => {};
    }

    let lastHandledAt = 0;

    const subscriber = tabSelected.subscribe(async (timestamp) => {
      if (!timestamp || timestamp === lastHandledAt) {
        return;
      }
      lastHandledAt = timestamp;

      if (await shouldGenerateFlowId(queryParams)) {
        await generateFlowId(queryParams, "tabSelected");
      }
    }, true);

    return () => {
      try {
        subscriber.unsubscribe();
      } catch (error) {
        console.error("[flow-id] failed to unsubscribe tabSelected", error);
      }
    };
  } catch (error) {
    console.error("[flow-id] syncFlowId failed", error);
    return () => {};
  }
}

export default {
  syncFlowId,
};
